import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useNotificationTypeSelectorEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.NotificationTypeSelector, false);

  return Boolean(isEnabled);
}